import { render, staticRenderFns } from "./CommissaryInfo.vue?vue&type=template&id=687e8384&"
import script from "./CommissaryInfo.vue?vue&type=script&lang=ts&"
export * from "./CommissaryInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports